// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87977b93","239":"7025cbb9","453":"6c44858d","455":"e57a59eb","557":"22d82a43","701":"9a6e1ac0","783":"3f96b330","872":"753fc21e","898":"2bfe6f08"}[chunkId] + ".chunk.js";
};